import React from "react";
import { StyledCard, StyledCardInner } from "./StyledCard";
import { CardProps } from "./types";

const Card: React.FC<React.PropsWithChildren<CardProps>> = ({ ribbon, children, background, ...props }) => {
  return (
    <StyledCard
      {...props}
      style={{
        padding: 0,
        border: "1px solid transparent",
        backgroundClip: "padding-box,border-box",
        backgroundOrigin: "padding-box,border-box",
        backgroundImage:
          "linear-gradient(0deg,#181414,#181414), linear-gradient(180deg,rgba(253,130,89,0.4),rgba(47,40,40,0.5))",
      }}
    >
      <StyledCardInner background={background} hasCustomBorder={!!props.borderBackground}>
        {ribbon}
        {children}
      </StyledCardInner>
    </StyledCard>
  );
};
export default Card;
